export default function EFDisplay(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M1.6 8.59828C1.6 8.04694 2.04694 7.6 2.59828 7.6H19.4V22.4H2.59828C2.04694 22.4 1.6 21.9531 1.6 21.4017V8.59828Z"
                stroke="currentColor"
                stroke-width="1.2"
            ></path>
            <rect x="19.6" y="4.6" width="10.8" height="21.8" rx="0.998279" stroke="currentColor" stroke-width="1.2"></rect>
            <mask id="path-3-inside-1_570_18945" fill="white">
                <rect x="21" y="8" width="8" height="3" rx="0.5"></rect>
            </mask>
            <rect x="21" y="8" width="8" height="3" rx="0.5" stroke="currentColor" stroke-width="2" mask="url(#path-3-inside-1_570_18945)"></rect>
            <path
                d="M26 21C26 21.5523 25.5523 22 25 22C24.4477 22 24 21.5523 24 21C24 20.4477 24.4477 20 25 20C25.5523 20 26 20.4477 26 21Z"
                fill="currentColor"
            ></path>
            <rect x="8" y="26" width="7" height="1" rx="0.5" fill="currentColor"></rect>
            <path
                d="M11.5 27C11.7761 27 12 26.7761 12 26.5L12 22.5C12 22.2239 11.7761 22 11.5 22C11.2239 22 11 22.2239 11 22.5L11 26.5C11 26.7761 11.2239 27 11.5 27Z"
                fill="currentColor"
            ></path>
        </svg>
    );
}
